var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [_c('section', {
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('div', {
    staticClass: "app2 flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadACK,
      "text": "Please wait loading Acknowledgment Receipt..."
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadACK = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isDownACK,
      "text": "Please wait downloading Acknowledgment..."
    },
    on: {
      "update:active": function($event) {
        _vm.isDownACK = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "content"
  }, [_c('div', {
    staticClass: "downloadAck justify-content-end",
    staticStyle: {
      "margin-right": "21%"
    }
  }, [_c('span', {
    on: {
      "click": _vm.generatePDF
    }
  }, [_vm._v("Download Acknowledgement")])])]), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    ref: "content"
  }, [_c('div', {
    staticClass: "ACKNOWLEDGMENT"
  }, [_c('div', {
    staticClass: "first-part"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-group mb-0",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('div', {
    staticClass: "card py-2",
    staticStyle: {
      "height": "auto"
    }
  }, [(!_vm.isMPS) ? _c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" AWB No. : ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.acknowledgementObj.ShippingId) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.isMPS) ? _c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" MPS ID. : ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.acknowledgementObj.MultiShipmentGroupID) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.isMPS || _vm.issku) ? _c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" Product Quantity. : ")]), _vm._v(" "), (_vm.issku) ? _c('span', [_vm._v(" " + _vm._s(_vm.skuTotalQuantity) + " ")]) : _vm._e(), _vm._v(" "), (_vm.isMPS) ? _c('span', [_vm._v(" " + _vm._s(_vm.mpsTotalQuantity) + " ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" Client Name : ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.acknowledgementObj.ClientName) + " ")])])]), _vm._v(" "), (!_vm.isMPS && !_vm.issku) ? _c('div', {
    staticClass: "card py-2",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" SR Pick Up Images: ")]), _vm._v(" "), (_vm.acknowledgementObj.SRPickDoneImages.length <= 0) ? _c('div', [_c('spam', [_vm._v(" No Image Available..")])], 1) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.acknowledgementObj.SRPickDoneImages), function(imagesrc, index) {
    return (Object.keys(_vm.acknowledgementObj).length != 0 && _vm.acknowledgementObj.SRPickDoneImages.length > 0) ? _c('span', [_c('img', {
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "src": imagesrc.Base64Image != '' ? imagesrc.Base64Image : '',
        "height": "auto",
        "width": "40px",
        "title": "Pickup Image",
        "alt": "Pickup Image"
      }
    })]) : _vm._e()
  }), 0)])]) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-group mb-0",
    staticStyle: {
      "border-top": "1px solid #c2cfd6"
    }
  }, [_c('div', {
    staticClass: "card py-2",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" Name : ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.acknowledgementObj.CustomerName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" Address : ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.acknowledgementObj.CustomerAddress) + " ")])])]), _vm._v(" "), (!_vm.isMPS && !_vm.issku) ? _c('div', {
    staticClass: "card py-2",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" Issue Category : ")]), _vm._v(" "), _c('span', [_vm._v(" Issues (customer) - " + _vm._s(_vm.acknowledgementObj.IssueCategory) + " ")])])]) : _vm._e()]), _vm._v(" "), (!_vm.isMPS && !_vm.issku) ? _c('div', {
    staticClass: "mb-0",
    staticStyle: {
      "border-top": "1px solid #c2cfd6",
      "background-color": "#fff"
    }
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.acknowledgementObj.ProductDetails), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductName) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductID) + "  ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.isMPS && _vm.pickDone.length > 0) ? _c('div', {
    staticClass: "mb-0",
    staticStyle: {
      "border-top": "1px solid #c2cfd6",
      "background-color": "#fff"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.pickDone), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ShippingID) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductName) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductID) + "  ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.isMPS && _vm.pickNotDone.length > 0) ? _c('div', {
    staticClass: "mb-0",
    staticStyle: {
      "border-top": "1px solid #c2cfd6",
      "background-color": "#fff"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.pickNotDone), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ShippingID) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductName) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductID) + "  ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.processcode) + "  ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.issku && _vm.pickDone.length > 0) ? _c('div', {
    staticClass: "mb-0",
    staticStyle: {
      "border-top": "1px solid #c2cfd6",
      "background-color": "#fff"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.pickDone), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductID) + "  ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductName) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.returnreason) + "  ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.issku && _vm.pickNotDone.length > 0) ? _c('div', {
    staticClass: "mb-0",
    staticStyle: {
      "border-top": "1px solid #c2cfd6",
      "background-color": "#fff"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.pickNotDone), function(row, index) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductID) + "  ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.ProductName) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.returnreason) + "  ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.processcode) + "  ")])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-group mb-0",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('div', {
    staticClass: "card py-2",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" Collected By : ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.acknowledgementObj.SRName))])]), _vm._v(" "), _c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" Date - Time.: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.acknowledgementObj.PickUpDateTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "card py-2",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "reverse_title"
  }, [_c('label', [_vm._v(" Is OTP Verified.: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.acknowledgementObj.IsOTPVerified))])])])])])])])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-group mb-0",
    staticStyle: {
      "border-bottom": "1px solid #c2cfd6"
    }
  }, [_c('div', {
    staticClass: "card text-white py-3 mobile-css",
    staticStyle: {
      "background-color": "#f58220 !important",
      "width": "440px"
    }
  }, [_c('h6', {
    staticClass: "login_title"
  }, [_vm._v(" REVERSE PICK-UP ACKNOWLEDGEMENT ")])]), _vm._v(" "), _c('div', {
    staticClass: "card p-2"
  }, [_c('div', [_c('img', {
    staticClass: "dark-logo",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "src": "static/img/logo.png",
      "alt": "homepage"
    }
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-group mb-0",
    staticStyle: {
      "border-top": "1px solid #c2cfd6",
      "background-color": "#fff"
    }
  }, [_c('div', {
    staticClass: "reverse_title reverse-headers"
  }, [_c('label', [_vm._v(" Customer Name & Address ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v(" SR.No ")]), _vm._v(" "), _c('th', [_vm._v(" Product Name ")]), _vm._v(" "), _c('th', [_vm._v(" Product ID ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "reverse_title reverse-headers"
  }, [_c('label', [_vm._v(" Pick Done Shipments ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v(" SR.No ")]), _vm._v(" "), _c('th', [_vm._v(" ShippingID ")]), _vm._v(" "), _c('th', [_vm._v(" Product Name ")]), _vm._v(" "), _c('th', [_vm._v(" Product ID ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "reverse_title reverse-headers"
  }, [_c('label', [_vm._v(" Pick Not Done Shipments ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v(" SR.No ")]), _vm._v(" "), _c('th', [_vm._v(" ShippingID ")]), _vm._v(" "), _c('th', [_vm._v(" Product Name ")]), _vm._v(" "), _c('th', [_vm._v(" Product ID ")]), _vm._v(" "), _c('th', [_vm._v(" Reason ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "reverse_title reverse-headers"
  }, [_c('label', [_vm._v(" Pick Done Products: ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v(" SR.No ")]), _vm._v(" "), _c('th', [_vm._v(" Product ID ")]), _vm._v(" "), _c('th', [_vm._v(" Product Name ")]), _vm._v(" "), _c('th', [_vm._v(" Issue Category ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "reverse_title reverse-headers"
  }, [_c('label', [_vm._v(" Pick Not Done Products: ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v(" SR.No ")]), _vm._v(" "), _c('th', [_vm._v(" Product ID ")]), _vm._v(" "), _c('th', [_vm._v(" Product Name ")]), _vm._v(" "), _c('th', [_vm._v(" Issue Category ")]), _vm._v(" "), _c('th', [_vm._v(" Reason ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5661185c","hasScoped":true}!./src/views/components/ReversePickAcknowledgment/ReversePickAcknowledgment.component.html
// module id = 1305
// module chunks = 1